var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_216_3038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 12.75C17.25 12.3522 17.092 11.9706 16.8107 11.6893C16.5294 11.408 16.1478 11.25 15.75 11.25H6.75L5.69 10.189C5.55064 10.0497 5.38522 9.93928 5.20317 9.86396C5.02112 9.78863 4.82602 9.74991 4.629 9.75H2.25C1.85218 9.75 1.47064 9.90804 1.18934 10.1893C0.908035 10.4706 0.75 10.8522 0.75 11.25V21.75C0.75 22.1478 0.908035 22.5294 1.18934 22.8107C1.47064 23.092 1.85218 23.25 2.25 23.25H15.75C16.1478 23.25 16.5294 23.092 16.8107 22.8107C17.092 22.5294 17.25 22.1478 17.25 21.75V12.75Z",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 17.25V8.25C20.25 7.85218 20.092 7.47064 19.8107 7.18934C19.5294 6.90804 19.1478 6.75 18.75 6.75H9.75L8.69 5.689C8.55064 5.54973 8.38522 5.43928 8.20317 5.36396C8.02112 5.28863 7.82602 5.24991 7.629 5.25H5.25C4.85218 5.25 4.47064 5.40804 4.18934 5.68934C3.90804 5.97064 3.75 6.35218 3.75 6.75",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 12.75V3.75C23.25 3.35218 23.092 2.97064 22.8107 2.68934C22.5294 2.40804 22.1478 2.25 21.75 2.25H12.75L11.69 1.189C11.5506 1.04973 11.3852 0.939283 11.2032 0.863959C11.0211 0.788634 10.826 0.749911 10.629 0.75H8.25C7.85218 0.75 7.47064 0.908035 7.18934 1.18934C6.90804 1.47064 6.75 1.85218 6.75 2.25",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_216_3038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolders);
export default __webpack_public_path__ + "static/media/Folders.469930729f4501309036ea260b07ef5a.svg";
export { ForwardRef as ReactComponent };